import { render } from "./EditProductView.vue?vue&type=template&id=0a617778&scoped=true"
import script from "./EditProductView.vue?vue&type=script&lang=js"
export * from "./EditProductView.vue?vue&type=script&lang=js"

import "./EditProductView.vue?vue&type=style&index=0&id=0a617778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a617778"]])

export default __exports__